import { FC } from 'react';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfSpec from '@elem/ui/ef-spec';
import EfSection from '@elem/ui/ef-section';
import VS from './VS';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('delta3Plus.AU3');
    const { pageStatus } = useDP3Store();

    return (
        <div className={`${css.thecomp}`} id="AU_3">
            <EfSpec />
            <div className="main">
                <EfSection theme="black" title={t('title')} />
                <VS />
            </div>
        </div>
    );
};

export default TheComp;
